import { render, staticRenderFns } from "./AnAccordion.vue?vue&type=template&id=132cebc9&"
import script from "./AnAccordion.vue?vue&type=script&lang=js&"
export * from "./AnAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports